import { ILayoutElement } from "@faire/web-api/indigofair/data/ILayoutElement";
import React from "react";

import { RenderCategoryLayoutElement } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/__internal__/RenderCategoryLayoutElement";
import { useLayoutElementsRequestId } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/__internal__/useLayoutElementsRequestId";
import { useIsFullWidthCategory } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useIsFullWidthCategory";
import { useCurrentCategoryModel } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentCategoryModel";

export const RenderCategoryPageLayoutElements = ({
  layoutElements,
}: {
  layoutElements: ILayoutElement[];
}) => {
  const categoryModel = useCurrentCategoryModel();
  const requestId = useLayoutElementsRequestId();
  const isFullWidthCategory = useIsFullWidthCategory();

  return (
    <>
      {layoutElements.map((layoutElement, index) => {
        return (
          <RenderCategoryLayoutElement
            key={`category-layout-element-${index}`}
            layoutElement={layoutElement}
            category={categoryModel}
            requestId={requestId}
            index={index}
            renderFullWidth={isFullWidthCategory}
          />
        );
      })}
    </>
  );
};
